export class CommonUtil {
 
    public static onlyAlphabets(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[a-zA-Z\s]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbers(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbersAndDash(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9-]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbersAndSlash(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9/]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static formatSsn(ssn: string): string {
        if (!ssn) return '';
        const cleaned = ssn.replace(/\D/g, '');
        if (cleaned.length !== 9) return ssn;
        return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 5)}-${cleaned.substring(5)}`;
    }
}